import { type FC } from 'react';
import ListingFilters, { type ListingFiltersProps } from '../ListingFilters/ListingFilters';
import LinkCTA from '2-core-elements/LinkCallToAction/LinkCTA';
import { getCleanFilters } from '../ListingFilters/ListingFilterHelpers';
import { type Filter } from '../ListingFilters/ListingFiltersTypes';

export interface ListingHeaderProps extends Omit<ListingFiltersProps, 'filters'> {
    clearFilterLabel?: string;
    title?: string;
    filters?: Filter[];
}

const ListingHeader: FC<ListingHeaderProps> = ({ clearFilterLabel, activeFilters, filters, setActiveFilters, disabled, title }) => {
    // console.info('Rendering ListingHeader', disabled);
    return (
        <div className="listing-app-header">
            <div className="listing-app-heading-container">
                <div className="listing-app-heading">{title}</div>
                {!!filters && !!filters.length && (
                    <LinkCTA
                        prefixIcon="person"
                        skin="1"
                        onClick={(): void => {
                            setActiveFilters(getCleanFilters(filters));
                        }}
                        disabled={disabled}
                    >
                        {clearFilterLabel}
                    </LinkCTA>
                )}
            </div>
            {!!filters && !!filters.length && (
                <ListingFilters
                    filters={filters}
                    activeFilters={activeFilters}
                    setActiveFilters={setActiveFilters}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default ListingHeader;
